import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, room, isDeleting }) => {
  if (!isOpen || !room) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[1100] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-md">
        <div className="p-6 space-y-4">
          <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center mx-auto">
            <Icon name="AlertTriangle" size={24} className="text-error" />
          </div>

          <div className="text-center">
            <h3 className="text-lg font-semibold text-text-primary mb-2">
              Delete Room?
            </h3>
            <p className="text-sm text-text-secondary">
              Are you sure you want to delete "{room?.name}"? This action cannot be undone.
            </p>
          </div>

          {room?.usageCount > 0 && (
            <div className="flex items-start gap-2 p-3 bg-warning/5 border border-warning/20 rounded-lg">
              <Icon name="AlertCircle" size={16} className="text-warning flex-shrink-0 mt-0.5" />
              <p className="text-xs text-text-secondary">
                This room has been selected {room?.usageCount} time{room?.usageCount !== 1 ? 's' : ''} by customers. Deleting it may affect existing visualizations.
              </p>
            </div>
          )}

          <div className="flex items-center gap-3 pt-2">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isDeleting}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isDeleting}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Delete Room
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;